const VIDEO_EXTENSIONS = ["mp4", "webm"];

export const isVideoMedia = (url?: string | null): boolean => {
  if (!url) return false;

  const extension = url.split(/[?#]/)[0].split(".").pop()?.toLowerCase();
  return !!extension && VIDEO_EXTENSIONS.includes(extension);
};
